<template>
  <div v-if="show" class="bh-modal">
    <div class="bh-overlay" @click="$emit('close')" />

    <div class="bh-dialog" role="dialog" aria-modal="true" aria-label="Benefit Success Modal">
      <!-- HEADER -->
      <div class="bh-header">
        <button class="bh-close" type="button" aria-label="Close" @click="$emit('close')">
          <img :src="closeIconSrc" alt="close" />
        </button>
      </div>

      <!-- BODY -->
      <div class="bh-body">
        <img :src="benefit?.image_url" alt="success" class="success-icon" />
        <div class="bh-card">
          <div class="bh-title" v-html="benefit?.title"></div>
          <div v-if="childSteps" class="bh-steps-container">
            <div class="bh-steps-title" v-html="childSteps?.title"></div>
            <ol class="bh-steps">
              <li v-for="(step, index) in childSteps?.child" :key="index" v-html="step?.title"></li>
            </ol>
          </div>
        </div>
      </div>

      <div class="bh-body">
        <div class="bh-return" @click="$emit('close')">
          Kembali
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BenefitSuccessModal',
  props: {
    show: { type: Boolean, default: false },
    benefit: { type: Object, default: null }
  },
  data () {
    return {
      closeIconSrc: require('@/assets/icons/close2.svg'),
    }
  },
  computed: {
    childSteps () {
      if (!this.benefit?.child) {
        return null
      }
      try {
        const parsed = JSON.parse(this.benefit.child)
        const result = parsed[0] || null
        return result
      } catch (e) {
        console.error('Error parsing child:', e, this.benefit.child)
        return null
      }
    }
  }
}
</script>

<style scoped>
.bh-modal {
  position: fixed;
  inset: 0;
  z-index: 99999;
}

.bh-overlay {
  position: absolute;
  inset: 0;
  background: rgba(17, 24, 39, 0.55);
}

.bh-dialog {
  position: absolute;
  padding: 12px 12px 20px 12px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(572px, calc(100% - 32px));
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0,0,0,0.25);
  overflow: hidden;
  max-height: calc(100vh - 56px);
  display: flex;
  flex-direction: column;
}

.bh-header {
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.bh-close {
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 0px;
  border-radius: 10px;
}
.bh-close:hover {
  background: rgba(17, 24, 39, 0.06);
}

.bh-body {
  padding: 16px 18px 18px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.bh-card {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  text-align: center;
}

.success-icon {
  width: 130px;
  margin: 0 auto;
  display: block;
}

.bh-title {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}

.bh-steps-container {
  background-color: #F5F6FA;
  border: 1px solid #D6DFF4;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  text-align: left;
}

.bh-steps-title {
  color: #374151;
  margin-bottom: 16px;
}

.bh-steps {
  list-style: none;
  padding: 0;
  margin: 0;
  counter-reset: step-counter;
}

.bh-steps li {
  counter-increment: step-counter;
  margin-bottom: 16px;
  display: flex;
  gap: 16px;
  color: #4B5563;
  line-height: 1.5;
}

.bh-steps li:last-child {
  margin-bottom: 0;
}

.bh-steps li::before {
  content: counter(step-counter);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  width: 24px;
  height: 24px;
  background-color: #FFFFFF;
  border: 1px solid #D6DFF4;
  border-radius: 50%;
  font-weight: 600;
  flex-shrink: 0;
}

.bh-return {
  padding: 12px 10px;
  background-color: #243E81;
  color: #FFFFFF;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 600px) {
  .bh-body { padding: 12px 14px 14px; }
  .bh-steps-container {
    padding: 16px;
  }
}
</style>